import { render, staticRenderFns } from "./global-video-screen-recording-popup.vue?vue&type=template&id=7a66b595&scoped=true"
import script from "./global-video-screen-recording-popup.vue?vue&type=script&lang=js"
export * from "./global-video-screen-recording-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a66b595",
  null
  
)

export default component.exports